<template>
    <div class="border border-dashed border-gray-400 rounded-sm p-4 flex flex-col items-center gap-2">
        <div class="text-xl/8 font-light text-gray-500">
            <slot name="description" />
        </div>

        <slot name="call-to-action" />
    </div>
</template>
